import { GET_PROFILE_DETAILS } from "../../Utils/types";

const initialState = {
  getProfileDetails: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE_DETAILS:
      return {
        ...state,
        getProfileDetails: action.payload,
      };
    default:
      return state;
  }
};
